import { createAsyncThunk } from '@reduxjs/toolkit';
import * as api from './api';

// for fixing circular dependencies
export const fetchUserData = createAsyncThunk('FETCH_USER_DATA', async () => {
  const { data } = await api.fetchCurrentUserData();

  return data;
});
